import { render, staticRenderFns } from "./GeneralModal.vue?vue&type=template&id=2c54dcff"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"
import style0 from "./GeneralModal.vue?vue&type=style&index=0&id=2c54dcff&prod&scoper=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports